import { Slot } from "@radix-ui/react-slot"
import { cva, VariantProps } from "class-variance-authority"
import React, { RefObject } from "react"

import { cn } from "@/utils/tailwind"

const textVariants = cva("", {
  variants: {
    variant: {
      default: "text-slate-700",
      secondary: "text-slate-500",
      link: "font-light text-slate-500 hover:text-slate-700",
    },
    size: {
      xs: "text-xs",
      sm: "text-sm",
      md: "text-base",
      lg: "text-lg",
      xl: "text-xl",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "md",
  },
})

interface Props extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof textVariants> {
  asChild?: boolean
  ref?: RefObject<HTMLSpanElement>
}

function Text({ className, variant, size, asChild = false, ref, children, ...props }: Props) {
  const Comp = asChild ? Slot : "span"
  return (
    <Comp className={cn(textVariants({ variant, size, className }))} ref={ref} {...props}>
      {children}
    </Comp>
  )
}

export { Text }
